import React, { useState, useEffect } from "react";
import AuthorLogin from "../modules/author/LoginForm";
import ReviewerLogin from "../modules/reviewer/ReviewerLogin";
import HostLogin from "../modules/host/HostLogin";
import AuthorRegistration from "../modules/author/RegistrationForm";
import ReviewerRegistration from "../modules/reviewer/ReviewerRegister";
import HostRegistration from "../modules/host/HostRegistration";
import Header from "./Header";
// import AdminLogin from "../modules/admin/AdminLogin";
import AdminRegistration from "../modules/admin/AdminRegistration";
import UILayout from "./UILayout";
import AuthorRegistrationEdit from "../modules/author/AuthorRegistrationEdit";
import ReviewerRegistrationEdit from "../modules/reviewer/ReviewerRegistrationEdit";
import { Container, Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
//import UIFooter from "./UIFooter";
import "../tps.css";
import UIFooter from "./UIFooter";

import axios from "axios";

const CommonLogin = () => {
    const [selectedRole, setSelectedRole] = useState("");
    const [showRegistration, setShowRegistration] = useState(false);
    const [isRegistered, setIsRegistered] = useState(false);
    const [showRegistrationEdit, setShowRegistrationEdit] = useState(false);
    const platformId = localStorage.getItem("platformID");

    // 🟢 NEW STATE: Role-based stats
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(false);

    const API = process.env.REACT_APP_API_BASE_URL;

    const handleRoleChange = (role) => {
        setSelectedRole(role);
        setShowRegistration(false);
        setShowRegistrationEdit(false);
        setIsRegistered(false);
        setStats(null); // 🟢 reset stats when switching role
    };

    // 🟢 NEW EFFECT: Fetch stats when role changes
    useEffect(() => {
        const fetchStats = async () => {
            if (!selectedRole || !platformId) return;
            setLoading(true);
            try {
                let res;
                if (selectedRole === "host") {
                    res = await axios.get(`${API}/api/host/auth-rev-paper/${platformId}`);
                } else if (selectedRole === "author") {
                    // 🟢 Overall stats for all authors in this platform
                    res = await axios.get(`${API}/api/host/auth-rev-paper/${platformId}`);
                } else if (selectedRole === "reviewer") {
                    // 🟢 Overall stats for all reviewers in this platform
                    res = await axios.get(`${API}/api/host/auth-rev-paper/${platformId}`);
                }

                setStats(res.data);
                console.log("Fetched Stats:", res.data);
            } catch (err) {
                console.error("Error fetching stats:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, [selectedRole, platformId, API]);

    // 🟢 Helper to render stats UI dynamically
    const renderStats = () => {
        if (loading) return <div className="text-center mt-3">Loading {selectedRole} stats...</div>;
        if (!stats) return null;

        // ✅ Derived counts from backend response (fixing mismatch)
        const totalAccepted = (stats.abstractAccepted ?? 0) + (stats.fullAccepted ?? 0) + (stats.revisionAccepted ?? 0);
        const totalPending = (stats.abstractPending ?? 0) + (stats.fullPending ?? 0) + (stats.revisionPending ?? 0);
        const totalRejected = (stats.abstractRejected ?? 0) + (stats.fullRejected ?? 0) + (stats.revisionRejected ?? 0);

        // 🟢 Right-side small boxes layout
        return (
            <div className="mt-3">
                {selectedRole === "host" && (
                    <div className="p-2">
                        <div className="small-box bg-success fixed-box mb-3">
                            <div className="inner">
                                <h4>Total Authors</h4>
                                <p>{stats.totalAuthors ?? 0}</p>
                            </div>
                        </div>
                        <div className="small-box bg-info fixed-box mb-3">
                            <div className="inner">
                                <h4>Total Reviewers</h4>
                                <p>{stats.totalReviewers ?? 0}</p>
                            </div>
                        </div>
                        <div className="small-box bg-warning fixed-box">
                            <div className="inner">
                                <h4>Total Papers</h4>
                                <p>{stats.paperCount ?? 0}</p>
                            </div>
                        </div>
                    </div>
                )}

                {selectedRole === "author" && (
                    <div className="p-2">
                        <div className="small-box bg-primary fixed-box mb-3">
                            <div className="inner">
                                <h4>Total Authors</h4>
                                <p>{stats.totalAuthors ?? 0}</p>
                            </div>
                        </div>
                        <div className="small-box bg-success fixed-box mb-3">
                            <div className="inner">
                                <h4>Approved Authors</h4>
                                <p>{stats.approvedAuthors ?? 0}</p>
                            </div>
                        </div>
                        <div className="small-box bg-warning fixed-box mb-3">
                            <div className="inner">
                                <h4>Pending Authors</h4>
                                <p>{stats.pendingAuthors ?? 0}</p>
                            </div>
                        </div>
                        <div className="small-box bg-danger fixed-box">
                            <div className="inner">
                                <h4>Rejected Authors</h4>
                                <p>{stats.rejectedAuthors ?? 0}</p>
                            </div>
                        </div>
                    </div>
                )}

                {selectedRole === "reviewer" && (
                    <div className="p-2">
                        <div className="small-box bg-primary fixed-box mb-3">
                            <div className="inner">
                                <h4>Total Reviewers</h4>
                                <p>{stats.totalReviewers ?? 0}</p>
                            </div>
                        </div>
                        <div className="small-box bg-success fixed-box mb-3">
                            <div className="inner">
                                <h4>Approved Reviewers</h4>
                                <p>{stats.approvedReviewers ?? 0}</p>
                            </div>
                        </div>
                        <div className="small-box bg-warning fixed-box mb-3">
                            <div className="inner">
                                <h4>Pending Reviewers</h4>
                                <p>{stats.pendingReviewers ?? 0}</p>
                            </div>
                        </div>
                        <div className="small-box bg-danger fixed-box">
                            <div className="inner">
                                <h4>Rejected Reviewers</h4>
                                <p>{stats.rejectedReviewers ?? 0}</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const renderLoginComponent = () => {
        switch (selectedRole) {
            case "author":
                return <AuthorLogin platformId={platformId} />;
            case "reviewer":
                return <ReviewerLogin platformId={platformId} />;
            case "host":
                return <HostLogin platformId={platformId} />;
            // case "admin":
            //     return <AdminLogin platformId={platformId} />;
            default:
                return null;
        }
    };

    const renderRegistrationComponent = () => {
        const props = { platformId, onRegistered: () => setIsRegistered(true) };
        switch (selectedRole) {
            case "author":
                return <AuthorRegistration {...props} />;
            case "reviewer":
                return <ReviewerRegistration {...props} />;
            //sujay 12/6/2025 no need the host registration
            // case "host":
            //     return <HostRegistration platformId={platformId} />;
            // case "admin":
            //     return <AdminRegistration platformId={platformId} />;
            default:
                return null;
        }
    };

    const renderEditRegistration = () => {
        switch (selectedRole) {
            case "author":
                return <AuthorRegistrationEdit />;
            case "reviewer":
                return <ReviewerRegistrationEdit />;
            default:
                return null;
        }
    };

    const getRegisterButtonText = () => {
        if (showRegistration) return "Hide Registration";
        if (selectedRole) return `New ${selectedRole.charAt(0).toUpperCase() + selectedRole.slice(1)} Registration`;
        return "Register";
    };

    return (
        <div className="container-cl ">
            {/* <UILayout /> */}
            <div className="mb-4">
                <Header />
                <Container className="mt-4">
                    <Row className="justify-content-center mb-4">
                        <ButtonGroup className="d-flex flex-wrap justify-content-center col-md-6">
                            <Button
                                className={`m-1  ${selectedRole === 'author' ? 'btn-sky' : 'btn-sky-outline'}`}
                                style={{ minHeight: "45px" }}
                                onClick={() => handleRoleChange("author")}
                            >
                                Author
                            </Button>
                            <Button
                                className={`m-1 ${selectedRole === 'reviewer' ? 'btn-sky' : 'btn-sky-outline'}`}
                                style={{ minHeight: "45px" }}
                                onClick={() => handleRoleChange("reviewer")}
                            >
                                Reviewer
                            </Button>
                            <Button
                                className={`m-1  ${selectedRole === 'host' ? 'btn-sky' : 'btn-sky-outline'}`}
                                style={{ minHeight: "45px" }}
                                onClick={() => handleRoleChange("host")}
                            >
                                Host
                            </Button>

                            {selectedRole &&
                                selectedRole !== "host" &&
                                (
                                    <>
                                        <Button
                                            className="m-1"
                                            style={{ minHeight: "45px" }}
                                            variant="warning"
                                            onClick={() => {
                                                setShowRegistration(!showRegistration);
                                                setShowRegistrationEdit(false); // hide edit if registration is shown
                                            }}
                                        >
                                            {getRegisterButtonText()}
                                        </Button>

                                        <Button
                                            className="m-1"
                                            style={{ minHeight: "45px" }}
                                            variant="warning"
                                            onClick={() => {
                                                setShowRegistrationEdit(!showRegistrationEdit);
                                                setShowRegistration(false); // hide registration if edit is shown
                                            }}
                                        >
                                            Edit Registration
                                        </Button>
                                    </>
                                )
                            }
                        </ButtonGroup>
                    </Row>

                    <Row>
                        {/* Left side */}
                        <Col md={8}>
                            <Row>
                                <Col md={6}>
                                    {renderLoginComponent()}
                                </Col>

                                <Col md={6}>
                                    {showRegistration && !isRegistered && (
                                        <Row>
                                            <Col md={12}>
                                                {renderRegistrationComponent()}
                                            </Col>
                                        </Row>
                                    )}

                                    {showRegistrationEdit && (
                                        <Row>
                                            <Col>
                                                {renderEditRegistration()}
                                            </Col>
                                        </Row>
                                    )}
                                </Col>
                            </Row>
                        </Col>

                        {/* 🟢 Right side — show stats or instructions based on state */}
                        <Col md={4}>
                            {/* Show stats when NOT in registration/edit mode */}
                            {selectedRole && !showRegistration && !showRegistrationEdit && renderStats()}

                            {/* 🟢 Show instructions when New Registration is open */}
                            {(selectedRole === "author" || selectedRole === "reviewer") &&
                                showRegistration &&
                                !showRegistrationEdit && (
                                    <div className="instru-auth text-left p-3 shadow-sm border rounded bg-light">
                                        <h4 className="text-center mb-3 text-primary">
                                            Instructions for {selectedRole === "author" ? "Authors" : "Reviewers"}
                                        </h4>
                                        <p>Please log in according to your role.</p>
                                        <p>If you are a new visitor to the website, you must register on at least one platform.</p>
                                        <p>
                                            If you have already registered on any platform, the website will help retrieve your registration details
                                            for registration on the currently selected platform or any other platform.
                                        </p>
                                        <p>
                                            Once your registration is validated by the selected platform host, you will be granted regular login
                                            access on that platform to carry out your respective role-based activities.
                                        </p>
                                    </div>
                                )}
                        </Col>
                    </Row>
                </Container>
            </div>
            <UIFooter />
        </div>
    );
};

export default CommonLogin;
